var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './OptionFilter.scss';
import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import classNames from 'classnames';
import React, { memo, useCallback } from 'react';
import { Select } from 'antd';
export const OptionFilter = memo((_a) => {
    var { className, defaultValue, filterOption, onChange, options, showArrow } = _a, rest = __rest(_a, ["className", "defaultValue", "filterOption", "onChange", "options", "showArrow"]);
    // Select onChange passes a second argument that cannot be passed
    // When provided onChange is a setState function.
    const handleChange = useCallback((value) => onChange(value), [onChange]);
    const hasFilterOption = filterOption || typeof filterOption === 'boolean';
    return (React.createElement(Select, Object.assign({}, rest, { allowClear: true, className: classNames('option-filter', className), defaultValue: defaultValue, filterOption: hasFilterOption ? filterOption : caseInsensitiveContainsFilterOption, onChange: handleChange, options: options, showSearch: true, suffixIcon: showArrow ? undefined : null })));
});
